import "antd/es/empty/style";
import _Empty from "antd/es/empty";
import "antd/es/spin/style";
import _Spin from "antd/es/spin";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import MenuItem from './MenuItem';
import MultiCascader from '../container';

var Column = function Column(props) {
  var data = props.data,
      columnWidth = props.columnWidth,
      depth = props.depth;
  var ref = useRef(null);

  var _useState = useState(columnWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1]; // 固定宽度，避免切换时菜单跳动的问题


  useEffect(function () {
    var _ref$current$getBound = ref.current.getBoundingClientRect(),
        refWidth = _ref$current$getBound.width;

    setWidth(refWidth);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-column",
    ref: ref,
    style: {
      width: "".concat(columnWidth || width, "px")
    }
  }, // eslint-disable-next-line no-nested-ternary
  !data ? /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-column-loading"
  }, /*#__PURE__*/React.createElement(_Spin, {
    size: "small"
  })) : data.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-column-empty"
  }, /*#__PURE__*/React.createElement(_Empty, {
    image: _Empty.PRESENTED_IMAGE_SIMPLE
  })) : /*#__PURE__*/React.createElement("ul", null, data.map(function (node) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: node.value.toString(),
      depth: depth,
      node: node
    });
  })));
};

export default (function (props) {
  var columnWidth = props.columnWidth;

  var _MultiCascader$useCon = MultiCascader.useContainer(),
      menuData = _MultiCascader$useCon.menuData;

  return /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-menu"
  }, menuData.map(function (menu, index) {
    var _menu$;

    return /*#__PURE__*/React.createElement(Column, {
      data: menu,
      columnWidth: columnWidth,
      depth: index,
      key: menu && ((_menu$ = menu[0]) === null || _menu$ === void 0 ? void 0 : _menu$.value) || index
    });
  }));
});